// extracted by mini-css-extract-plugin
export default {"categories-suggestions-title":"_1o67zzh","categoriesSuggestionsTitle":"_1o67zzh","title-text":"_nqxl9i","titleText":"_nqxl9i"};